module.exports = __webpack_public_path__ + "img/img3.ff671326.png";